export default __webpack_public_path__ + "static/media/success.65edf10f.png";